import React from 'react';

const HandoverCommentsBox = ({ onCommentChange, value, placeholder = "Enter any issues or comments..." }) => {
  return (
    <div className="handover-comments-box">
      <label style={{ 
        display: 'block', 
        marginBottom: '6px', 
        fontSize: '13px', 
        fontWeight: 600, 
        color: '#4a5568' 
      }}>
        Comments
      </label>
      <textarea
        value={value}
        onChange={(e) => onCommentChange && onCommentChange(e.target.value)}
        placeholder={placeholder}
        rows="3"
        style={{
          width: '100%',
          padding: '10px 12px',
          border: '2px solid #e2e8f0',
          borderRadius: '6px',
          fontSize: '13px',
          fontFamily: 'inherit',
          resize: 'vertical',
          transition: 'border-color 0.2s'
        }}
        onFocus={(e) => e.target.style.borderColor = '#667eea'}
        onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
      />
    </div>
  );
};

export default HandoverCommentsBox;


